export default "__VITE_ASSET__D_lxY1GK__"